import { authHeader, handleResponse } from '../helpers';
export const DealerWiseTopBuyRptServices = {
    GetProductDealerSummary,
    // GetDealers // New service method
};

function GetProductDealerSummary(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
   
    return fetch(`${process.env.REACT_APP_API_URL}UserLoyalityLogRpt/GetProductDealerSummary`, requestOptions)
        .then(handleResponse);
}

// function GetDealers() {
//     const requestOptions = {
//         method: 'POST',
//         headers: authHeader(),
//         body: JSON.stringify(data)
//     };
//     return fetch(`${process.env.REACT_APP_API_URL}UserLoyalityLogRpt/GetProductDealerSummary`, requestOptions) // Use the correct base URL
//         .then(handleResponse);
// }